module.exports = __webpack_public_path__ + "static/img/game-logo-og.c97c403.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-og.png
// module id = yYnp
// module chunks = 0 1 2 3 4 5 6